import { Formik, Form } from "formik";
import { MedicalTravelModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";

import {
  Box,
  Progressbar,
  ErrorList,
  handleSubmitClick,
  RadioGroupForm,
  Button,
  Heading,
} from "@ogt/ui";

export const FOR_ME = "for-me";
export const FOR_PATIENT = "for-patient";

export default function MedicalTravel() {
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 0;
  return (
    <div>
      <Formik<MedicalTravelModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/kontaktuppgifter");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          compensationfor: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänligen välj ett svaralternativ för att gå vidare till nästa fråga",
            (value) => {
              return value === FOR_ME || value === FOR_PATIENT;
            }
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-40 w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form ref={formRef}>
              <Box>
                <Heading className="mb-6" focusable id="compensationFor">
                  Vem söker du ersättning för?
                </Heading>

                <ErrorList errors={errors} />
                <RadioGroupForm
                  name="compensationfor"
                  ariaLabelledBy="compensationFor"
                  orientation="vertical"
                  variant="box"
                  options={[
                    {
                      id: "forMe",
                      value: FOR_ME,
                      label: "För mig själv",
                    },
                    {
                      id: "forOther",
                      value: FOR_PATIENT,
                      label: " För patient som jag är vårdnadshavare för",
                    },
                  ]}
                />
              </Box>
              <div className="w-full text-right">
                <Button
                  className="w-full sm:w-auto"
                  onClick={handleSubmitClick(formRef)}
                  type="submit"
                >
                  Gå vidare
                </Button>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
